import { BILLING_CURRENCY } from '@/features/billing/consts/billing'
import { currencyHelper } from '@/helpers'

export const getCurrency = () => {
  return currencyHelper.general.getCurrency(BILLING_CURRENCY)
}
